// /src/composables/useNavItems.ts
import { RouteLocationRaw } from 'vue-router';

export interface NavItem {
	key: string;
	title: string;
	icon: string;
	to: RouteLocationRaw;
}

export function useNavItems(): NavItem[] {
	return [
		{ key: 'units', title: 'Units', icon: 'mdi-domain', to: { name: 'Units' } },
		{ key: 'coverages', title: 'Coverages', icon: 'mdi-clipboard-list-outline', to: { name: 'Coverages' } },
		{ key: 'documents', title: 'Documents', icon: 'mdi-file-document', to: { name: 'Documents' } },
		{ key: 'interests', title: 'Interests', icon: 'mdi-shield-check', to: { name: 'Interests' } },
		// …extend as needed
	];
}
